import React, { PureComponent, Fragment } from 'react';
import debounce from 'lodash.debounce';
import { Tooltip } from '@pwc/appkit-react/lib/Tooltip';
import { FaTimes, FaRedo, FaSearch } from 'react-icons/fa';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

class SearchBar extends PureComponent {
  constructor() {
    super(...arguments);
    this.state = {
      isOpen: false,
      searchText: ''
    };
    this.openSearch = () => {
      this.setState(_ref => {
        let {
          isOpen
        } = _ref;
        return {
          isOpen: !isOpen
        };
      });
    };
    this.search = event => {
      event.persist();
      const value = event.target.value;
      this.setState({
        searchText: value
      }, () => {
        this.performDebouncedSearch(value);
      });
    };
    this.performDebouncedSearch = debounce(value => this.props.onSearch(value), 500);
    this.cancel = () => {
      this.setState(_ref2 => {
        let {
          isOpen
        } = _ref2;
        return {
          isOpen: !isOpen,
          searchText: ''
        };
      });
      this.props.onCancel();
    };
  }
  componentDidMount() {
    // duplicating state for the debounce functionality
    // so the user doesn't wait x sec for the text to show in the input
    this.setState({
      searchText: this.props.value
    });
  }
  componentWillUnmount() {
    this.props.onSearch('');
  }
  render() {
    const {
      Component,
      placeholder,
      withResetIcon
    } = this.props;
    const {
      isOpen,
      searchText
    } = this.state;
    const inputProps = {
      onChange: this.search,
      value: searchText
    };
    const defaultSearchInput = /*#__PURE__*/React.createElement("div", {
      className: "search-input-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-wrapper"
    }, /*#__PURE__*/React.createElement("input", _extends({
      autoFocus: true,
      type: "text",
      placeholder: placeholder
    }, inputProps))), /*#__PURE__*/React.createElement("div", {
      className: "search-icon-wrapper"
    }, /*#__PURE__*/React.createElement(FaTimes, {
      className: "close-icon",
      onClick: this.cancel
    })));
    return /*#__PURE__*/React.createElement(Fragment, null, Component ? /*#__PURE__*/React.createElement(Component, inputProps) : /*#__PURE__*/React.createElement("div", {
      className: "icons-container"
    }, withResetIcon ? /*#__PURE__*/React.createElement(Tooltip, {
      content: 'Reset grid to its default settings',
      placement: "top"
    }, /*#__PURE__*/React.createElement(FaRedo, {
      onClick: this.props.reset
    })) : '', /*#__PURE__*/React.createElement("div", {
      className: "search-bar"
    }, isOpen ? defaultSearchInput : /*#__PURE__*/React.createElement(FaSearch, {
      className: "search-icon",
      onClick: this.openSearch
    }))));
  }
}
SearchBar.defaultProps = {
  Component: null
};

export { SearchBar as default };
